<template><div><h1>VUX V2.9.4 released</h1>
<h2><a href="/en/components/picker.html">Picker</a></h2>
<ul><li>[fix] Fix chain mode get value is wrong when quickly scroll multiple children.</li>
</ul>
<h2><a href="/en/components/tab.html">Tab</a></h2>
<ul><li>[fix] tab  #2850</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.9.4 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.9.4-143.vue?67951b86